import React, { ReactNode } from 'react';
import { useSessionStorage } from 'usehooks-ts';

export const CONCEALER_SESSION_STORAGE_KEY = 'webtrader.storage.numbers-concealer-is-enabled';

export const NumbersConcealer: React.FC<
  React.PropsWithChildren<{
    'data-test-prefix'?: string;
    children: ReactNode;
  }>
> = React.memo((props) => {
  const [sessionStorageVal] = useSessionStorage(CONCEALER_SESSION_STORAGE_KEY, false);

  if (sessionStorageVal)
    return (
      <span data-test={`${props['data-test-prefix'] ? `${props['data-test-prefix']}-` : ''}number-is-concealed`}>
        ****
      </span>
    );

  return <>{props.children}</>;
});
